import { createGenericStore } from '@/stores/utils/genericStore.js'
import axios from 'axios'
import { unwrapResource } from './chatStoreUtils.js'
import { useMessageStore } from './messageStore.js'

const messageReactionStoreOptions = {
  actions: {
    async reactToMessage(conversationId, messageId, reaction) {
      this.error = null

      try {
        const response = await axios.post(`/api/v1/conversations/${conversationId}/messages/${messageId}/reactions`, { reaction })
        const messageReaction = unwrapResource(response)
        useMessageStore().patchMessageReactionState(conversationId, messageId, messageReaction, 'added')
        return messageReaction
      } catch (error) {
        this.error = error
        throw error
      }
    },

    async removeReaction(conversationId, messageId, reaction) {
      this.error = null

      try {
        await axios.delete(`/api/v1/conversations/${conversationId}/messages/${messageId}/reactions/${encodeURIComponent(reaction)}`)
        useMessageStore().removeMessageReactionByNameState(conversationId, messageId, reaction)
      } catch (error) {
        this.error = error
        throw error
      }
    }
  }
}

export const useMessageReactionStore = createGenericStore(
  'chat-message-reactions',
  '/api/v1/conversations',
  messageReactionStoreOptions
)
